import { render, staticRenderFns } from "./ShadowDomainConfiguration.vue?vue&type=template&id=ae2c853a&scoped=true"
import script from "./ShadowDomainConfiguration.vue?vue&type=script&lang=js"
export * from "./ShadowDomainConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ShadowDomainConfiguration.vue?vue&type=style&index=0&id=ae2c853a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2c853a",
  null
  
)

export default component.exports